<div style="padding:2rem;display:flex;gap:1rem;flex-direction: column;">
    <div style="display:flex;align-items:center;gap:2rem;">
        <mat-form-field appearance="outline" yearFormat style="width:200px">
            <mat-label>År (ÅÅÅÅ)</mat-label>
            <input matInput [matDatepicker]="dpYear" [ngModel]="year" (blur)="setYear($event.target, null)"
                (keydown.enter)="setYear($event.target, null)">
            <mat-datepicker-toggle matIconSuffix [for]="dpYear"></mat-datepicker-toggle>
            <mat-datepicker #dpYear startView="multi-year" (yearSelected)="setYear($event, dpYear)">
            </mat-datepicker>
        </mat-form-field>
        <mat-slide-toggle [(ngModel)]="includePipeline">Inkluder vægtet pipeline</mat-slide-toggle>
        <mat-form-field appearance="outline" style="width:260px">
            <mat-label>Forretningsområde</mat-label>
            <mat-select [(ngModel)]="selectedDepartmentId">
                <mat-option [value]="null">Alle</mat-option>
                @for (dept of departments; track dept.id) {
                <mat-option [value]="dept.id">{{dept.name}}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
    <app-departments-summary [year]="year" [includePipeline]="includePipeline" [departmentId]="selectedDepartmentId"></app-departments-summary>
    <app-consultant-ranking [year]="year" [includePipeline]="includePipeline" [departmentId]="selectedDepartmentId" ranking="highest"></app-consultant-ranking>
    <app-consultant-ranking [year]="year" [includePipeline]="includePipeline" [departmentId]="selectedDepartmentId" ranking="lowest"></app-consultant-ranking>
</div>
